// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operandGrid {
    width: 204px;
    display: flex;
    flex-direction: row;
    border: 1px solid #D5D5D5;
    border-radius: 3px;
    flex-wrap: wrap;
    margin-bottom: 4px;
}

    .operandGrid > div {
        height: 50px;
        width: 50px;
        display: flex;
        justify-content: center;
    }

        .operandGrid > div:hover{
            background-color: #AEC7E0;
        }

        .operandGrid > div > span {
            align-self: center;
        }

.formula-ok {
    /*background: -webkit-linear-gradient(top, #FFFFFF 0%, #008000 100%), linear-gradient(to bottom, #FFFFFF 0%, #008000 100%);*/
    color: green;
}

.formula-bad {
    /*background: -webkit-linear-gradient(top, #FFFFFF 0%, #FF0000 100%), linear-gradient(to bottom, #FFFFFF 0%, #FF0000 100%);*/
    color: red;
}

.feCol {
    margin: 2px;
}

.variableTree {
    display: flex;
    flex: 1 1 auto;
}

.functionTree {
    display: flex;
    height: 300px;
    overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/formulaEditor/formulaEditor.control.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;IAEI;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,uBAAuB;IAC3B;;QAEI;YACI,yBAAyB;QAC7B;;QAEA;YACI,kBAAkB;QACtB;;AAER;IACI,4HAA4H;IAC5H,YAAY;AAChB;;AAEA;IACI,4HAA4H;IAC5H,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB","sourcesContent":[".operandGrid {\n    width: 204px;\n    display: flex;\n    flex-direction: row;\n    border: 1px solid #D5D5D5;\n    border-radius: 3px;\n    flex-wrap: wrap;\n    margin-bottom: 4px;\n}\n\n    .operandGrid > div {\n        height: 50px;\n        width: 50px;\n        display: flex;\n        justify-content: center;\n    }\n\n        .operandGrid > div:hover{\n            background-color: #AEC7E0;\n        }\n\n        .operandGrid > div > span {\n            align-self: center;\n        }\n\n.formula-ok {\n    /*background: -webkit-linear-gradient(top, #FFFFFF 0%, #008000 100%), linear-gradient(to bottom, #FFFFFF 0%, #008000 100%);*/\n    color: green;\n}\n\n.formula-bad {\n    /*background: -webkit-linear-gradient(top, #FFFFFF 0%, #FF0000 100%), linear-gradient(to bottom, #FFFFFF 0%, #FF0000 100%);*/\n    color: red;\n}\n\n.feCol {\n    margin: 2px;\n}\n\n.variableTree {\n    display: flex;\n    flex: 1 1 auto;\n}\n\n.functionTree {\n    display: flex;\n    height: 300px;\n    overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
